<template>
  <div id="widget-app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "WidgetApp",
};
</script>

<style>
.hoverable {
  transition: all 300ms ease-in-out;
  opacity: 100%;
  cursor: pointer;
}

.hoverable:hover {
  opacity: 80%;
}
</style>
